import React, { useEffect } from 'react';
import ReactDOM from 'react-dom';

let currentPinnedDiv = null;

const Message = ({ message, duration = 2000, onClose, type = "error" }) => {
  useEffect(() => {
    // if (type !== "pinned") {
    const timer = setTimeout(() => {
      onClose();
    }, duration);

    return () => clearTimeout(timer);
    // }
  }, [duration, onClose, type]);

  let _class = "ui-message";
  if (type === "toast") {
    _class = "ui-toast";
  }

  return (
    <div onClick={onClose} className={`${_class} ${type} ${type === "pinned" ? "ui-pin" : ""}`}>
      <div>{message}</div>
      {type === "pinned" && (
        <button className="ui-message-close">
          ×
        </button>
      )}
    </div>
  );
};

export const showError = (_obj, duration = 3000, type = "error") => {
  let _message = _obj?.error || "There was an error.";
  if (_obj?.kwargs?.message) {
    _message = _obj.kwargs.message;
  }

  const div = document.createElement('div');
  document.body.appendChild(div);



  const removeMessage = () => {
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
  };

  ReactDOM.render(
    <Message type={type} message={_message} duration={duration} onClose={removeMessage} />,
    div
  );
};

export const showMessage = (message, duration, type = "message", pos = [0, 0]) => {
  const div = document.createElement("div");

  if (type === "pinned" && currentPinnedDiv) {
    ReactDOM.unmountComponentAtNode(currentPinnedDiv);
    document.body.removeChild(currentPinnedDiv);
    currentPinnedDiv = null;
  }

  document.body.appendChild(div);



  if (type === "toast") {
    div.style.position = "fixed";
    div.style.top = `${pos[0]}px`;
    div.style.left = `${pos[1]}px`;
    div.style.zIndex = 9999;
    div.style.pointerEvents = "auto"; // keep clickable
  }




  const removeMessage = () => {
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    if (currentPinnedDiv === div) currentPinnedDiv = null;
  };

  ReactDOM.render(
    <Message
      type={type}
      message={message}
      duration={duration}
      onClose={removeMessage}
    />,
    div
  );

  if (type === "pinned") currentPinnedDiv = div;
};

export default Message;
